// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"595":"9d8a9ebb","734":"7d9d1aa1","3717":"9d8a9ebb","6495":"e94b6211"}[chunkId] + ".chunk.css";
};